/**
 * Utility functions for safe error handling in TypeScript
 */

/**
 * Safely extracts a message from an unknown error object
 */
export function getErrorMessage(error: unknown): string {
    if (error instanceof Error) {
        return error.message;
    }

    if (typeof error === 'object' && error !== null && 'message' in error) {
        return String((error as { message: unknown }).message);
    }

    if (typeof error === 'string') {
        return error;
    }

    return 'An unexpected error occurred';
}

/**
 * Checks if an unknown error is an instance of Error
 */
export function isError(error: unknown): error is Error {
    return error instanceof Error;
}

/**
 * A Firestore query refused because its composite index is missing (or still
 * building). The raw message carries a console link, which must never reach a user.
 */
export function isMissingIndexError(error: unknown): boolean {
  const { code, message } = (error ?? {}) as { code?: unknown; message?: unknown };
  const text = typeof message === 'string' ? message : '';
  return /requires an index|firestore\/indexes|create_composite/i.test(text) ||
    ((code === 'failed-precondition' || code === 'firestore/failed-precondition') && /index/i.test(text));
}
